// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"h29ZT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPayloads", ()=>createPayloads);
var _objectWithoutProperties = require("@babel/runtime/helpers/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _bowserUltralight = require("bowser-ultralight");
var _bowserUltralightDefault = parcelHelpers.interopDefault(_bowserUltralight);
var _interactionMetrics = require("@atlaskit/react-ufo/interaction-metrics");
var _additionalPayload = require("../additional-payload");
var _bundleEvalTiming = require("../bundle-eval-timing");
var _constants = require("../common/constants");
var _config = require("../config");
var _customTimings = require("../custom-timings");
var _hiddenTiming = require("../hidden-timing");
var _initialPageLoadExtraTiming = require("../initial-page-load-extra-timing");
var _interactionMetrics1 = require("../interaction-metrics");
var _resourceTiming = require("../resource-timing");
var _roundNumber = require("../round-number");
var _ssr = require("../ssr");
var _vc = require("../vc");
var _utils = require("./common/utils");
var _excluded = [
    "labelStack",
    "time"
], _excluded2 = [
    "stopTime",
    "labelStack"
], _excluded3 = [
    "labelStack"
], _excluded4 = [
    "labelStack"
];
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _definePropertyDefault.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function getUfoNameOverride(interaction) {
    var ufoName = interaction.ufoName, apdex = interaction.apdex;
    try {
        var ufoNameOverrides = (0, _config.getUfoNameOverrides)();
        if (ufoNameOverrides != null) {
            var metricKey = apdex.length > 0 ? apdex[0].key : '';
            if (ufoNameOverrides[ufoName][metricKey]) return ufoNameOverrides[ufoName][metricKey];
        }
        return ufoName;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return ufoName;
    }
}
function stringifyLabelStackFully(labelStack) {
    return labelStack.map(function(l) {
        if ((0, _utils.isSegmentLabel)(l)) return "".concat(l.name, ":").concat(l.segmentId);
        return l.name;
    }).join('/');
}
function labelStackStartWith(labelStack, startWith) {
    return stringifyLabelStackFully(labelStack).startsWith(stringifyLabelStackFully(startWith));
}
function getEarliestLegacyStopTime(interaction, labelStack) {
    var earliestLegacyStopTime = null;
    interaction.apdex.forEach(function(a) {
        var _a$labelStack, _earliestLegacyStopTi;
        if (!(a !== null && a !== void 0 && a.stopTime)) return;
        if (!labelStackStartWith((_a$labelStack = a.labelStack) !== null && _a$labelStack !== void 0 ? _a$labelStack : [], labelStack)) return;
        if (a.stopTime > interaction.start && ((_earliestLegacyStopTi = earliestLegacyStopTime) !== null && _earliestLegacyStopTi !== void 0 ? _earliestLegacyStopTi : a.stopTime) >= a.stopTime) earliestLegacyStopTime = a.stopTime;
    });
    return earliestLegacyStopTime;
}
function getBm3EndTimeOrFallbackValue(interaction) {
    var _getEarliestLegacySto;
    var labelStack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var fallbackValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : interaction.end;
    if (interaction.type === 'press') return fallbackValue;
    return (_getEarliestLegacySto = getEarliestLegacyStopTime(interaction, labelStack)) !== null && _getEarliestLegacySto !== void 0 ? _getEarliestLegacySto : fallbackValue;
}
var getPageVisibilityUpToTTI = function getPageVisibilityUpToTTI(interaction) {
    var start = interaction.start;
    var bm3EndTimeOrInteractionEndTime = getBm3EndTimeOrFallbackValue(interaction);
    return (0, _hiddenTiming.getPageVisibilityState)(start, bm3EndTimeOrInteractionEndTime);
};
var getPageVisibilityUpToTTAI = function getPageVisibilityUpToTTAI(interaction) {
    var start = interaction.start, end = interaction.end;
    return (0, _hiddenTiming.getPageVisibilityState)(start, end);
};
var getVisibilityStateFromPerformance = function getVisibilityStateFromPerformance(stop) {
    try {
        var results = performance.getEntriesByType('visibility-state');
        if (!results || results.length === 0) return null;
        return results.reduce(function() {
            var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var _ref = arguments.length > 1 ? arguments[1] : undefined, name = _ref.name, startTime = _ref.startTime;
            if (startTime > stop) return acc;
            if (acc === null && name === null) return null;
            if (acc === null) return name;
            if (acc !== name) return 'mixed';
            return acc;
        }, null);
    } catch (e) {
        return null;
    }
};
var getMoreAccuratePageVisibilityUpToTTI = function getMoreAccuratePageVisibilityUpToTTI(interaction) {
    var old = getPageVisibilityUpToTTI(interaction);
    var tti = getEarliestLegacyStopTime(interaction, []);
    if (!tti) return old;
    var buffered = getVisibilityStateFromPerformance(tti);
    if (!buffered) return old;
    if (buffered !== old) return 'mixed';
    return old;
};
var getMoreAccuratePageVisibilityUpToTTAI = function getMoreAccuratePageVisibilityUpToTTAI(interaction) {
    var old = getPageVisibilityUpToTTAI(interaction);
    var buffered = getVisibilityStateFromPerformance(interaction.end);
    if (!buffered) return old;
    if (buffered !== old) return 'mixed';
    return old;
};
var getInteractionStatus = function getInteractionStatus(interaction) {
    var originalInteractionStatus = interaction.abortReason ? 'ABORTED' : 'SUCCEEDED';
    var hasBm3TTI = interaction.apdex.length > 0;
    var overrideStatus = hasBm3TTI ? 'SUCCEEDED' : originalInteractionStatus;
    return {
        originalInteractionStatus: originalInteractionStatus,
        overrideStatus: overrideStatus
    };
};
var getResourceTimings = function getResourceTimings(start, end) {
    var _resourceTiming$getRe;
    return (_resourceTiming$getRe = _resourceTiming.getResourceTimings(start, end)) !== null && _resourceTiming$getRe !== void 0 ? _resourceTiming$getRe : undefined;
};
var getBundleEvalTimings = function getBundleEvalTimings(start) {
    return _bundleEvalTiming.getBundleEvalTimings(start);
};
var getSSRSuccess = function getSSRSuccess(type) {
    return type === 'page_load' ? _ssr.getSSRSuccess() : undefined;
};
var getSSRFeatureFlags = function getSSRFeatureFlags(type) {
    return type === 'page_load' ? _ssr.getSSRFeatureFlags() : undefined;
};
var getPaintMetrics = function getPaintMetrics(type) {
    if (type !== 'page_load') return {};
    var metrics = {};
    performance.getEntriesByType('paint').forEach(function(entry) {
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    return metrics;
};
var getVCMetrics = function getVCMetrics(interaction) {
    var _config$vc, _config$vc2, _interaction$apdex;
    var config = (0, _config.getConfig)();
    if (!(config !== null && config !== void 0 && (_config$vc = config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled)) return {};
    if (interaction.type !== 'page_load' && interaction.type !== 'transition') return {};
    var ssr = interaction.type === 'page_load' && config !== null && config !== void 0 && (_config$vc2 = config.vc) !== null && _config$vc2 !== void 0 && _config$vc2.ssr ? {
        ssr: getSSRDoneTimeValue(config)
    } : null;
    (0, _interactionMetrics1.postInteractionLog).setVCObserverSSRConfig(ssr);
    var tti = (_interaction$apdex = interaction.apdex) === null || _interaction$apdex === void 0 || (_interaction$apdex = _interaction$apdex[0]) === null || _interaction$apdex === void 0 ? void 0 : _interaction$apdex.stopTime;
    var prefix = 'ufo';
    var result = (0, _vc.getVCObserver)().getVCResult(_objectSpread({
        start: interaction.start,
        stop: interaction.end,
        tti: tti,
        prefix: prefix,
        vc: interaction.vc
    }, ssr));
    (0, _interactionMetrics1.postInteractionLog).setLastInteractionFinishVCResult(result);
    var VC = result === null || result === void 0 ? void 0 : result['metrics:vc'];
    if (!VC || !(result !== null && result !== void 0 && result["".concat(prefix, ":vc:clean")])) return result;
    var interactionStatus = getInteractionStatus(interaction);
    var pageVisibilityUpToTTAI = getPageVisibilityUpToTTAI(interaction);
    if (interactionStatus.originalInteractionStatus !== 'SUCCEEDED' || pageVisibilityUpToTTAI !== 'visible') return result;
    return _objectSpread(_objectSpread({}, result), {}, {
        'metric:vc90': VC['90']
    });
};
var getNavigationMetrics = function getNavigationMetrics(type) {
    if (type !== 'page_load') return {};
    var entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return {};
    var navigation = entries[0];
    var metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart),
        nextHopProtocol: navigation.nextHopProtocol
    };
    return {
        'metrics:navigation': metrics
    };
};
var getPPSMetrics = function getPPSMetrics(interaction) {
    var _interaction$apdex2;
    var start = interaction.start, end = interaction.end;
    var config = (0, _config.getConfig)();
    var interactionStatus = getInteractionStatus(interaction);
    var pageVisibilityUpToTTAI = getPageVisibilityUpToTTAI(interaction);
    var tti = (_interaction$apdex2 = interaction.apdex) === null || _interaction$apdex2 === void 0 || (_interaction$apdex2 = _interaction$apdex2[0]) === null || _interaction$apdex2 === void 0 ? void 0 : _interaction$apdex2.stopTime;
    var ttai = interactionStatus.originalInteractionStatus === 'SUCCEEDED' && pageVisibilityUpToTTAI === 'visible' ? Math.round(end - start) : undefined;
    var PPSMetricsAtTTI = tti !== undefined ? (0, _additionalPayload.getLighthouseMetrics)({
        start: start,
        stop: tti
    }) : null;
    var PPSMetricsAtTTAI = ttai !== undefined ? (0, _additionalPayload.getLighthouseMetrics)({
        start: start,
        stop: interaction.end
    }) : null;
    if (config !== null && config !== void 0 && config.shouldCalculateLighthouseMetricsFromTTAI && PPSMetricsAtTTAI !== null) return PPSMetricsAtTTAI;
    if (PPSMetricsAtTTI !== null) return _objectSpread(_objectSpread({}, PPSMetricsAtTTI), {}, {
        'metrics@ttai': PPSMetricsAtTTAI
    });
    return {};
};
function getSSRProperties(type) {
    return {
        'ssr:success': getSSRSuccess(type),
        'ssr:featureFlags': getSSRFeatureFlags(type)
    };
}
var getBrowserMetadata = function getBrowserMetadata() {
    var data = {};
    var now = new Date();
    data['event:localHour'] = now.getHours(); // returns the hours for this date according to local time
    data['event:localDayOfWeek'] = now.getDay(); // Sunday - Saturday : 0 - 6
    data['event:localTimezoneOffset'] = now.getTimezoneOffset(); // A number representing the difference, in minutes, between the date as evaluated in the UTC time zone and as evaluated in the local time zone.
    if (navigator.userAgent != null) {
        var browser = (0, _bowserUltralightDefault.default).getParser(navigator.userAgent);
        data['event:browser:name'] = browser.getBrowserName();
        data['event:browser:version'] = browser.getBrowserVersion();
    }
    if (navigator.hardwareConcurrency != null) data['event:cpus'] = navigator.hardwareConcurrency;
    if (navigator.deviceMemory != null) data['event:memory'] = navigator.deviceMemory;
    // eslint-disable-next-line compat/compat
    if (navigator.connection != null) {
        data['event:network:effectiveType'] = navigator.connection.effectiveType;
        data['event:network:rtt'] = navigator.connection.rtt;
        data['event:network:downlink'] = navigator.connection.downlink;
    }
    return data;
};
var getTracingContextData = function getTracingContextData(interaction) {
    var trace = interaction.trace, start = interaction.start;
    var tracingContextData = {};
    if (trace) tracingContextData = {
        'ufo:tracingContext': {
            'X-B3-TraceId': trace.traceId,
            'X-B3-SpanId': trace.spanId,
            // eslint-disable-next-line compat/compat
            browserTimeOrigin: +(performance.timeOrigin + start).toFixed(2)
        }
    };
    return tracingContextData;
};
// interaction metric
function optimizeLabelStack(labelStack) {
    return labelStack.map(function(ls) {
        return _objectSpread({
            n: ls.name
        }, ls.segmentId ? {
            s: ls.segmentId
        } : {});
    });
}
function optimizeCustomData(interaction) {
    var customData = interaction.customData, legacyMetrics = interaction.legacyMetrics;
    var customDataMap = customData.reduce(function(result, _ref2) {
        var _result$get$data, _result$get;
        var labelStack = _ref2.labelStack, data = _ref2.data;
        var label = stringifyLabelStackFully(labelStack);
        var value = (_result$get$data = (_result$get = result.get(label)) === null || _result$get === void 0 ? void 0 : _result$get.data) !== null && _result$get$data !== void 0 ? _result$get$data : {};
        result.set(label, {
            labelStack: optimizeLabelStack(labelStack),
            data: Object.assign(value, data)
        });
        return result;
    }, new Map());
    if (legacyMetrics) {
        var legacyMetricsFiltered = legacyMetrics.filter(function(item) {
            return item.type === 'PAGE_LOAD';
        }).reduce(function(result, currentValue) {
            for(var _i = 0, _Object$entries = Object.entries(currentValue.custom || {}); _i < _Object$entries.length; _i++){
                var _result$get$data2, _result$get2;
                var _Object$entries$_i = (0, _slicedToArrayDefault.default)(_Object$entries[_i], 2), _key = _Object$entries$_i[0], value = _Object$entries$_i[1];
                var label = stringifyLabelStackFully([]);
                var labelValue = (_result$get$data2 = (_result$get2 = result.get(label)) === null || _result$get2 === void 0 ? void 0 : _result$get2.data) !== null && _result$get$data2 !== void 0 ? _result$get$data2 : {};
                result.set(label, {
                    labelStack: optimizeLabelStack([]),
                    data: Object.assign(labelValue, (0, _definePropertyDefault.default)({}, _key, value))
                });
            }
            return result;
        }, new Map());
        return [].concat((0, _toConsumableArrayDefault.default)(customDataMap.values()), (0, _toConsumableArrayDefault.default)(legacyMetricsFiltered.values()));
    }
    return (0, _toConsumableArrayDefault.default)(customDataMap.values());
}
function optimizeReactProfilerTimings(reactProfilerTimings, interactionStart) {
    var reactProfilerTimingsMap = reactProfilerTimings.reduce(function(result, _ref3) {
        var labelStack = _ref3.labelStack, startTime = _ref3.startTime, commitTime = _ref3.commitTime, actualDuration = _ref3.actualDuration, type = _ref3.type;
        if (labelStack && startTime >= interactionStart) {
            var label = stringifyLabelStackFully(labelStack);
            var start = Math.round(startTime);
            var end = Math.round(commitTime);
            var timing = result.get(label) || {
                labelStack: optimizeLabelStack(labelStack),
                startTime: start,
                endTime: end,
                mountCount: 0,
                rerenderCount: 0,
                renderDuration: 0
            };
            if (start < timing.startTime) timing.startTime = start;
            if (end > timing.endTime) timing.endTime = end;
            if (type === 'mount') timing.mountCount += 1;
            if (type === 'update') timing.rerenderCount += 1;
            timing.renderDuration += Math.round(actualDuration);
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return (0, _toConsumableArrayDefault.default)(reactProfilerTimingsMap.values());
}
function optimizeRedirects(redirects, interactionStart) {
    var lastRedirectTime = interactionStart;
    var updatedRedirects = redirects.sort(function(a, b) {
        return a.time - b.time;
    }).reduce(function(result, redirect) {
        var fromInteractionName = redirect.fromInteractionName, time = redirect.time;
        if (lastRedirectTime >= interactionStart) result.push({
            labelStack: [
                {
                    n: fromInteractionName
                }
            ],
            startTime: Math.round(lastRedirectTime),
            endTime: Math.round(time)
        });
        lastRedirectTime = time;
        return result;
    }, []);
    return updatedRedirects;
}
function optimizeHoldInfo(holdInfo, interactionStart) {
    var holdInfoMap = holdInfo.reduce(function(result, hold) {
        var labelStack = hold.labelStack, name = hold.name, start = hold.start, end = hold.end, ignoreOnSubmit = hold.ignoreOnSubmit;
        if (labelStack && !ignoreOnSubmit && start >= interactionStart) {
            var label = stringifyLabelStackFully([].concat((0, _toConsumableArrayDefault.default)(labelStack), [
                {
                    name: name
                }
            ]));
            var startTime = Math.round(start);
            var endTime = Math.round(end);
            var timing = result.get(label) || {
                labelStack: optimizeLabelStack([].concat((0, _toConsumableArrayDefault.default)(labelStack), [
                    {
                        name: name
                    }
                ])),
                startTime: startTime,
                endTime: endTime
            };
            if (startTime < timing.startTime) timing.startTime = startTime;
            if (endTime > timing.endTime) timing.endTime = endTime;
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return (0, _toConsumableArrayDefault.default)(holdInfoMap.values());
}
function optimizeSpans(spans, interactionStart) {
    var updatedSpans = spans.reduce(function(result, span) {
        var labelStack = span.labelStack, type = span.type, name = span.name, start = span.start, end = span.end;
        if (labelStack && start >= interactionStart) result.push({
            labelStack: optimizeLabelStack([].concat((0, _toConsumableArrayDefault.default)(labelStack), [
                {
                    name: name
                }
            ])),
            startTime: Math.round(start),
            endTime: Math.round(end),
            type: type
        });
        return result;
    }, []);
    return updatedSpans;
}
function optimizeRequestInfo(requestInfo, interactionStart) {
    var updatedRequestInfo = requestInfo.reduce(function(result, reqInfo) {
        var labelStack = reqInfo.labelStack, name = reqInfo.name, start = reqInfo.start, end = reqInfo.end, networkStart = reqInfo.networkStart, networkComplete = reqInfo.networkComplete;
        var startTime = networkStart !== null && networkStart !== void 0 ? networkStart : start;
        var endTime = networkComplete !== null && networkComplete !== void 0 ? networkComplete : end;
        if (labelStack && start >= interactionStart && endTime) result.push({
            labelStack: optimizeLabelStack([].concat((0, _toConsumableArrayDefault.default)(labelStack), [
                {
                    name: name
                }
            ])),
            startTime: Math.round(startTime),
            endTime: Math.round(endTime)
        });
        return result;
    }, []);
    return updatedRequestInfo;
}
function optimizeCustomTimings(customTimings, interactionStart) {
    var updatedCustomTimings = customTimings.reduce(function(result, item) {
        Object.keys(item.data).forEach(function(key) {
            if (item.data[key].startTime >= interactionStart) result.push({
                labelStack: [
                    {
                        n: key
                    }
                ],
                startTime: Math.round(item.data[key].startTime),
                endTime: Math.round(item.data[key].endTime)
            });
        });
        return result;
    }, []);
    return updatedCustomTimings;
}
function optimizeMarks(marks) {
    return marks.map(function(_ref4) {
        var labelStack = _ref4.labelStack, time = _ref4.time, others = (0, _objectWithoutPropertiesDefault.default)(_ref4, _excluded);
        return _objectSpread(_objectSpread({}, others), {}, {
            labelStack: labelStack && optimizeLabelStack(labelStack),
            time: Math.round(time)
        });
    });
}
function optimizeApdex(apdex) {
    return apdex.map(function(_ref5) {
        var stopTime = _ref5.stopTime, labelStack = _ref5.labelStack, others = (0, _objectWithoutPropertiesDefault.default)(_ref5, _excluded2);
        return _objectSpread(_objectSpread({}, others), {}, {
            stopTime: Math.round(stopTime)
        }, labelStack ? {
            labelStack: optimizeLabelStack(labelStack)
        } : {});
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function objectToArray() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(obj).reduce(function(result, key) {
        result.push({
            label: key,
            data: obj[key]
        });
        return result;
    }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    []);
}
function getBM3SubmetricsTimings(submetrics) {
    if (!submetrics) return null;
    var submetricsTimings = submetrics.filter(function(item) {
        return typeof item.stop === 'number' && !!item.key && typeof item.start === 'number';
    }).map(function(item) {
        var childSubmetrics;
        var newKey = "include/".concat(item.key);
        if (item.submetrics) childSubmetrics = getBM3SubmetricsTimings(item.submetrics);
        return _objectSpread((0, _definePropertyDefault.default)({}, newKey, {
            endTime: item.stop - item.start,
            startTime: item.start
        }), childSubmetrics ? childSubmetrics : {});
    });
    return submetricsTimings;
}
function getBm3TrackerTimings(interaction) {
    var interactionLegacyMetrics = interaction.legacyMetrics;
    if (!interactionLegacyMetrics) return {};
    var legacyMetrics = interactionLegacyMetrics.map(function(item) {
        var _item$config, _item$config2, _item$marks;
        return {
            key: item.key,
            startTime: item.start,
            stopTime: item.stop,
            type: (_item$config = item.config) === null || _item$config === void 0 ? void 0 : _item$config.type,
            reactUFOName: (_item$config2 = item.config) === null || _item$config2 === void 0 ? void 0 : _item$config2.reactUFOName,
            fmp: ((_item$marks = item.marks) === null || _item$marks === void 0 ? void 0 : _item$marks['fmp']) || item.stop,
            source: 'bm3',
            timings: (0, _customTimings.getBm3Timings)(item.marks, item.config.timings),
            submetrics: getBM3SubmetricsTimings(item.submetrics),
            pageVisibleState: item.pageVisibleState
        };
    }).filter(function(item) {
        return !!item.type;
    });
    return {
        legacyMetrics: legacyMetrics
    };
}
function getSSRDoneTimeValue(config) {
    var _config$ssr, _config$ssr2;
    return config !== null && config !== void 0 && (_config$ssr = config.ssr) !== null && _config$ssr !== void 0 && _config$ssr.getSSRDoneTime ? config === null || config === void 0 || (_config$ssr2 = config.ssr) === null || _config$ssr2 === void 0 ? void 0 : _config$ssr2.getSSRDoneTime() : _ssr.getSSRDoneTime();
}
function createInteractionMetricsPayload(interaction, interactionId) {
    var _window$location, _config$additionalPay;
    var interactionPayloadStart = performance.now();
    var config = (0, _config.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    var end = interaction.end, start = interaction.start, ufoName = interaction.ufoName, knownSegments = interaction.knownSegments, rate = interaction.rate, type = interaction.type, abortReason = interaction.abortReason, routeName = interaction.routeName, featureFlags = interaction.featureFlags, previousInteractionName = interaction.previousInteractionName, isPreviousInteractionAborted = interaction.isPreviousInteractionAborted, abortedByInteractionName = interaction.abortedByInteractionName;
    var pageVisibilityAtTTI = getPageVisibilityUpToTTI(interaction);
    var pageVisibilityAtTTAI = getPageVisibilityUpToTTAI(interaction);
    var segments = config.killswitchNestedSegments ? [] : knownSegments;
    var isDetailedPayload = pageVisibilityAtTTAI === 'visible';
    var isPageLoad = type === 'page_load';
    var calculatePageVisibilityFromTheStartOfPageLoad = config.enableBetterPageVisibilityApi && isPageLoad;
    var moreAccuratePageVisibilityAtTTI = calculatePageVisibilityFromTheStartOfPageLoad ? getMoreAccuratePageVisibilityUpToTTI(interaction) : null;
    var moreAccuratePageVisibilityAtTTAI = calculatePageVisibilityFromTheStartOfPageLoad ? getMoreAccuratePageVisibilityUpToTTAI(interaction) : null;
    var labelStack = interaction.labelStack ? {
        labelStack: optimizeLabelStack(interaction.labelStack)
    } : {};
    // Page Load
    var getPageLoadInteractionMetrics = function getPageLoadInteractionMetrics() {
        var _config$ssr3;
        if (!isPageLoad) return {};
        var config = (0, _config.getConfig)();
        var SSRDoneTimeValue = getSSRDoneTimeValue(config);
        var SSRDoneTime = SSRDoneTimeValue !== undefined ? {
            SSRDoneTime: Math.round(SSRDoneTimeValue)
        } : {};
        return _objectSpread(_objectSpread({}, SSRDoneTime), {}, {
            isBM3ConfigSSRDoneAsFmp: interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp,
            isUFOConfigSSRDoneAsFmp: interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp || !!(config !== null && config !== void 0 && (_config$ssr3 = config.ssr) !== null && _config$ssr3 !== void 0 && _config$ssr3.getSSRDoneTime)
        });
    };
    // Detailed payload. Page visibility = visible
    var getDetailedInteractionMetrics = function getDetailedInteractionMetrics() {
        if (!isDetailedPayload) return {};
        var spans = [].concat((0, _toConsumableArrayDefault.default)(interaction.spans), (0, _toConsumableArrayDefault.default)((0, _interactionMetrics.interactionSpans)));
        (0, _interactionMetrics.interactionSpans).length = 0;
        return {
            errors: interaction.errors.map(function(_ref6) {
                var labelStack = _ref6.labelStack, others = (0, _objectWithoutPropertiesDefault.default)(_ref6, _excluded3);
                return _objectSpread(_objectSpread({}, others), {}, {
                    labelStack: labelStack && optimizeLabelStack(labelStack)
                });
            }),
            holdActive: (0, _toConsumableArrayDefault.default)(interaction.holdActive.values()),
            redirects: optimizeRedirects(interaction.redirects, start),
            holdInfo: optimizeHoldInfo(interaction.holdInfo, start),
            spans: optimizeSpans(spans, start),
            requestInfo: optimizeRequestInfo(interaction.requestInfo, start),
            customTimings: optimizeCustomTimings(interaction.customTimings, start),
            bundleEvalTimings: objectToArray(getBundleEvalTimings(start)),
            resourceTimings: objectToArray(getResourceTimings(start, end))
        };
    };
    // Page load & detailed payload
    var getPageLoadDetailedInteractionMetrics = function getPageLoadDetailedInteractionMetrics() {
        var _config$ssr4;
        if (!isPageLoad || !isDetailedPayload) return {};
        var config = (0, _config.getConfig)();
        return {
            initialPageLoadExtraTimings: objectToArray(_initialPageLoadExtraTiming.getTimings()),
            SSRTimings: config !== null && config !== void 0 && (_config$ssr4 = config.ssr) !== null && _config$ssr4 !== void 0 && _config$ssr4.getSSRTimings ? config.ssr.getSSRTimings() : objectToArray(_ssr.getSSRTimings())
        };
    };
    var newUFOName = (0, _utils.sanitizeUfoName)(ufoName);
    return {
        actionSubject: 'experience',
        action: 'measured',
        eventType: 'operational',
        source: 'measured',
        tags: [
            'observability'
        ],
        attributes: {
            properties: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
                // basic
                'event:hostname': ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname) || 'unknown',
                'event:product': config.product,
                'event:schema': '1.0.0',
                'event:source': {
                    name: 'react-ufo/web',
                    version: (0, _constants.REACT_UFO_VERSION),
                    payloadSource: 'platform'
                },
                'event:region': config.region || 'unknown',
                'experience:key': 'custom.interaction-metrics',
                'experience:name': newUFOName
            }, getBrowserMetadata()), getSSRProperties(type)), getPPSMetrics(interaction)), getPaintMetrics(type)), getNavigationMetrics(type)), getVCMetrics(interaction)), (_config$additionalPay = config.additionalPayloadData) === null || _config$additionalPay === void 0 ? void 0 : _config$additionalPay.call(config, interaction)), getTracingContextData(interaction)), {}, {
                interactionMetrics: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
                    namePrefix: config.namePrefix || '',
                    segmentPrefix: config.segmentPrefix || '',
                    interactionId: interactionId,
                    pageVisibilityAtTTI: pageVisibilityAtTTI,
                    pageVisibilityAtTTAI: pageVisibilityAtTTAI,
                    experimental__pageVisibilityAtTTI: moreAccuratePageVisibilityAtTTI,
                    experimental__pageVisibilityAtTTAI: moreAccuratePageVisibilityAtTTAI,
                    // raw interaction metrics
                    rate: rate,
                    routeName: routeName,
                    type: type,
                    abortReason: abortReason,
                    featureFlags: featureFlags,
                    previousInteractionName: previousInteractionName,
                    isPreviousInteractionAborted: isPreviousInteractionAborted,
                    abortedByInteractionName: abortedByInteractionName,
                    // performance
                    apdex: optimizeApdex(interaction.apdex),
                    end: Math.round(end),
                    start: Math.round(start),
                    segments: segments.map(function(_ref7) {
                        var labelStack = _ref7.labelStack, others = (0, _objectWithoutPropertiesDefault.default)(_ref7, _excluded4);
                        return _objectSpread(_objectSpread({}, others), {}, {
                            labelStack: optimizeLabelStack(labelStack)
                        });
                    }),
                    marks: optimizeMarks(interaction.marks),
                    customData: optimizeCustomData(interaction),
                    reactProfilerTimings: optimizeReactProfilerTimings(interaction.reactProfilerTimings, start)
                }, labelStack), getPageLoadInteractionMetrics()), getDetailedInteractionMetrics()), getPageLoadDetailedInteractionMetrics()), getBm3TrackerTimings(interaction)),
                'ufo:payloadTime': (0, _roundNumber.roundEpsilon)(performance.now() - interactionPayloadStart)
            })
        }
    };
}
function createPayloads(interactionId, interaction) {
    var ufoNameOverride = getUfoNameOverride(interaction);
    var modifiedInteraction = _objectSpread(_objectSpread({}, interaction), {}, {
        ufoName: ufoNameOverride
    });
    var interactionMetricsPayload = createInteractionMetricsPayload(modifiedInteraction, interactionId);
    return [
        interactionMetricsPayload
    ];
}

},{"@babel/runtime/helpers/objectWithoutProperties":"lEiUo","@babel/runtime/helpers/toConsumableArray":"gbrKk","@babel/runtime/helpers/slicedToArray":"gmMd0","@babel/runtime/helpers/defineProperty":"2DsLZ","bowser-ultralight":"B1gNo","@atlaskit/react-ufo/interaction-metrics":"ckufz","../additional-payload":"JuXHH","../bundle-eval-timing":"gS1h3","../common/constants":"gM7FM","../config":"acZBX","../custom-timings":"jlqIp","../hidden-timing":"eQE8K","../initial-page-load-extra-timing":"9leYL","../interaction-metrics":"K96Qv","../resource-timing":"jplWh","../round-number":"dEmLP","../ssr":"1fEeT","../vc":"eLXHQ","./common/utils":"2tBtR","@atlaspack/transformer-js/src/esmodule-helpers.js":"87JRQ"}],"B1gNo":[function(require,module,exports,__globalThis) {
!function(e, r) {
    module.exports = r();
}(this, function() {
    return function(e) {
        var r = {};
        function t(n) {
            if (r[n]) return r[n].exports;
            var i = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        return t.m = e, t.c = r, t.d = function(e, r, n) {
            t.o(e, r) || Object.defineProperty(e, r, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, r) {
            if (1 & r && (e = t(e)), 8 & r) return e;
            if (4 & r && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & r && "string" != typeof e) for(var i in e)t.d(n, i, (function(r) {
                return e[r];
            }).bind(null, i));
            return n;
        }, t.n = function(e) {
            var r = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(r, "a", r), r;
        }, t.o = function(e, r) {
            return Object.prototype.hasOwnProperty.call(e, r);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(1)) && n.__esModule ? n : {
                default: n
            };
            /*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ var o = function() {
                function e() {}
                return e.getParser = function(e, r) {
                    if (void 0 === r && (r = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, r);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(2)) && n.__esModule ? n : {
                default: n
            };
            var o = function() {
                function e(e, r) {
                    if (void 0 === r && (r = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== r && this.parse();
                }
                var r = e.prototype;
                return r.getUA = function() {
                    return this._ua;
                }, r.test = function(e) {
                    return e.test(this._ua);
                }, r.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var r = i.default.find(function(r) {
                        if ("function" == typeof r.test) return r.test(e);
                        if (r.test instanceof Array) return r.test.some(function(r) {
                            return e.test(r);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return r && (this.parsedResult.browser = r.describe(this.getUA())), this.parsedResult.browser;
                }, r.isMobile = function() {
                    return this.test(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
                }, r.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, r.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, r.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, r.parse = function() {
                    return this.parseBrowser(), this;
                }, r.getResult = function() {
                    return Object.assign({}, this.parsedResult);
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            function n(e, r) {
                var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (t) return (t = t.call(e)).next.bind(t);
                if (Array.isArray(e) || (t = function(e, r) {
                    if (!e) return;
                    if ("string" == typeof e) return i(e, r);
                    var t = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === t && e.constructor && (t = e.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(e);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return i(e, r);
                }(e)) || r && e && "number" == typeof e.length) {
                    t && (e = t);
                    var n = 0;
                    return function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        };
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function i(e, r) {
                (null == r || r > e.length) && (r = e.length);
                for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
                return n;
            }
            r.__esModule = !0, r.default = void 0;
            var o = function(e, r) {
                var t = r.match(e);
                return t && t.length > 0 && t[1] || "";
            }, s = function(e, r) {
                var t = r.match(e);
                return t && t.length > 1 && t[2] || "";
            }, u = /version\/(\d+(\.?_?\d+)+)/i, a = function(e, r) {
                void 0 === e && (e = []);
                for(var t, i = n(e); !(t = i()).done;){
                    var s = t.value, u = o(s, r);
                    if (u) return u;
                }
                return null;
            }, d = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Googlebot",
                            version: a([
                                /googlebot\/(\d+(\.\d+))/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                u,
                                /(?:opera)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                /(?:opr|opios)[\s/](\S+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Samsung Internet for Android",
                            version: a([
                                u,
                                /(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        return {
                            name: "NAVER Whale Browser",
                            version: a([
                                u,
                                /(?:whale)[\s/](\d+(?:\.\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Coast",
                            version: a([
                                u,
                                /(?:coast)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Touch",
                            version: a([
                                /(?:opt)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Internet Explorer",
                            version: a([
                                /(?:msie |rv:)(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: a([
                                /\sedg\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: s(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e)
                        };
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Vivaldi",
                            version: a([
                                /vivaldi\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Tizen",
                            version: a([
                                /(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Firefox",
                            version: a([
                                /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Electron",
                            version: a([
                                /(?:electron)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chromium",
                            version: a([
                                /(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chrome",
                            version: a([
                                /(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Google Search",
                            version: a([
                                /(?:GSA)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: function(e) {
                        var r = !e.test(/like android/i), t = e.test(/android/i);
                        return r && t;
                    },
                    describe: function(e) {
                        return {
                            name: "Android Browser",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Safari",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var r = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: o(r, e),
                            version: s(r, e)
                        };
                    }
                }
            ];
            r.default = d, e.exports = r.default;
        }
    ]);
});

},{}],"ckufz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interactionSpans", ()=>interactionSpans);
parcelHelpers.export(exports, "addCustomSpans", ()=>addCustomSpans);
var interactionSpans = [];
function addCustomSpans(name, start) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: [
            {
                name: 'custom'
            }
        ],
        size: size
    };
    interactionSpans.push(customSpan);
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"87JRQ"}],"gS1h3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "configure", ()=>configure);
parcelHelpers.export(exports, "getBundleEvalTimings", ()=>getBundleEvalTimings);
var _roundNumber = require("../round-number");
var config = null;
function configure(bundleEvalTimingConfiguration) {
    config = bundleEvalTimingConfiguration;
}
var getPerformanceObject = function getPerformanceObject() {
    var _window;
    return ((_window = window) !== null && _window !== void 0 ? _window : {}).performance;
};
function getBundleEvalTimings(interactionStartTime) {
    if (config == null) return {};
    var started = {};
    var timings = {};
    var cachedConfig = config;
    var performance = getPerformanceObject();
    performance === null || performance === void 0 || performance.getEntriesByType('mark').forEach(function(mark) {
        var result = cachedConfig.mapPerformanceMark(mark.name);
        if (!result) return;
        var type = result.type, name = result.name;
        if (type === 'start' && mark.startTime >= interactionStartTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: (0, _roundNumber.roundEpsilon)(started[name].startTime - interactionStartTime),
                duration: (0, _roundNumber.roundEpsilon)(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (Object.keys(timings).length === 0) return {};
    return timings;
}

},{"../round-number":"dEmLP","@atlaspack/transformer-js/src/esmodule-helpers.js":"87JRQ"}],"dEmLP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "roundEpsilon", ()=>roundEpsilon);
var roundEpsilon = function roundEpsilon(num) {
    var places = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
};

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"87JRQ"}],"gM7FM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REACT_UFO_VERSION", ()=>REACT_UFO_VERSION);
var REACT_UFO_VERSION = '1.0.1';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"87JRQ"}],"jlqIp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBm3Timings", ()=>getBm3Timings);
parcelHelpers.export(exports, "UFOBM3TimingsToUFO", ()=>UFOBM3TimingsToUFO);
parcelHelpers.export(exports, "addBM3TimingsToUFO", ()=>addBM3TimingsToUFO);
var _react = require("react");
var _interactionContext = require("../interaction-context");
var _interactionContextDefault = parcelHelpers.interopDefault(_interactionContext);
var _interactionIdContext = require("../interaction-id-context");
var _interactionMetrics = require("../interaction-metrics");
function getBm3Timings(marks, timingConfigs) {
    var bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach(function(item) {
        if (!item.startMark || !item.endMark) return;
        var startTime = marks[item.startMark];
        if (!startTime) return;
        var endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function UFOBM3TimingsToUFO(_ref) {
    var marks = _ref.marks, timings = _ref.timings;
    var interactionContext = (0, _react.useContext)((0, _interactionContextDefault.default));
    var interactionId = (0, _interactionIdContext.getInteractionId)().current;
    (0, _react.useMemo)(function() {
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            var interactionType = (0, _interactionMetrics.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            var bm3Timings = getBm3Timings(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function addBM3TimingsToUFO(marks, timingsConfig) {
    var interactionId = (0, _interactionIdContext.getInteractionId)().current;
    if (interactionId) {
        var interactionType = (0, _interactionMetrics.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        var bm3Timings = getBm3Timings(marks, timingsConfig);
        (0, _interactionMetrics.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

},{"react":"iNt6H","../interaction-context":"iKs69","../interaction-id-context":"jOwrL","../interaction-metrics":"K96Qv","@atlaspack/transformer-js/src/esmodule-helpers.js":"87JRQ"}],"9leYL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addTimingFromPerformanceMark", ()=>addTimingFromPerformanceMark);
parcelHelpers.export(exports, "getTimings", ()=>getTimings);
var timings = [];
function addTimingFromPerformanceMark(name, startMark, stopMark) {
    var cleanStart = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var cleanStop = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    timings.push({
        name: name,
        startMark: startMark,
        stopMark: stopMark,
        cleanStart: cleanStart,
        cleanStop: cleanStop
    });
}
function getTimings() {
    var reportedTimingsObj = {};
    timings.forEach(function(_ref) {
        var name = _ref.name, startMark = _ref.startMark, stopMark = _ref.stopMark, cleanStart = _ref.cleanStart, cleanStop = _ref.cleanStop;
        var startEntryList = performance.getEntriesByName(startMark);
        var stopEntryList = performance.getEntriesByName(stopMark);
        if ((startEntryList === null || startEntryList === void 0 ? void 0 : startEntryList.length) > 0 && (stopEntryList === null || stopEntryList === void 0 ? void 0 : stopEntryList.length) > 0) {
            var startEntry = startEntryList[startEntryList.length - 1];
            var stopEntry = stopEntryList[stopEntryList.length - 1];
            var startTime = startEntry.startTime;
            var duration = stopEntry.startTime - startTime;
            var timing = {
                startTime: Math.round(startTime),
                duration: Math.round(duration)
            };
            reportedTimingsObj[name] = timing;
        }
        if (cleanStart) performance.clearMarks(startMark);
        if (cleanStop) performance.clearMarks(stopMark);
    });
    return reportedTimingsObj;
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"87JRQ"}],"jplWh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "configure", ()=>(0, _config.configure));
parcelHelpers.export(exports, "getResourceTimings", ()=>(0, _main.getResourceTimings));
parcelHelpers.export(exports, "startResourceTimingBuffer", ()=>(0, _utils.startResourceTimingBuffer));
var _config = require("./common/utils/config");
var _main = require("./main");
var _utils = require("./utils");

},{"./common/utils/config":"bZYSh","./main":"cMhW8","./utils":"AzgY4","@atlaspack/transformer-js/src/esmodule-helpers.js":"87JRQ"}],"bZYSh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "configure", ()=>configure);
parcelHelpers.export(exports, "getConfig", ()=>getConfig);
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _config = require("../../../config");
function _createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
var getAllowedParams = function getAllowedParams() {
    var config = (0, _config.getConfig)();
    return (config === null || config === void 0 ? void 0 : config.allowedResourcesParams) || defaultAllowedParams;
};
var handleQueryParams = function handleQueryParams(urlString) {
    try {
        if (typeof urlString !== 'string') return urlString;
        var url = new URL(urlString);
        var params = new URLSearchParams(url.search);
        var allowedParams = getAllowedParams();
        var _iterator = _createForOfIteratorHelper(params), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = (0, _slicedToArrayDefault.default)(_step.value, 1), key = _step$value[0];
                if (!allowedParams.includes(key)) url.searchParams.delete(key);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return url.toString();
    } catch (e) {
        return urlString;
    }
};
var config = {
    mapResources: function mapResources(url) {
        return url;
    },
    sanitiseEndpoints: function sanitiseEndpoints(url) {
        return handleQueryParams(url);
    }
};
function configure(resourceTimingConfig) {
    var newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: function sanitiseEndpoints(url) {
            var sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return handleQueryParams(sanitised);
            return sanitised;
        }
    };
    config = newConfig;
}
var getConfig = function getConfig() {
    return config;
};

},{"@babel/runtime/helpers/slicedToArray":"gmMd0","../../../config":"acZBX","@atlaspack/transformer-js/src/esmodule-helpers.js":"87JRQ"}],"cMhW8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResourceTimings", ()=>getResourceTimings);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _config = require("../config");
var _roundNumber = require("../round-number");
var _config1 = require("./common/utils/config");
var _resourceTimingBuffer = require("./common/utils/resource-timing-buffer");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _definePropertyDefault.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var cacheableTypes = [
    'script',
    'link'
];
var resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
var CACHE_NETWORK = 'network';
var CACHE_MEMORY = 'memory';
var CACHE_DISK = 'disk';
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
var calculateTransferType = function calculateTransferType(type, duration, size) {
    if (!cacheableTypes.includes(type)) return CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return CACHE_MEMORY;
    if (size === 0 && duration > 0) return CACHE_DISK;
    if (size === undefined) return null;
    return CACHE_NETWORK;
};
var getWindowObject = function getWindowObject() {
    return typeof window !== 'undefined' && !!window ? window : undefined;
};
var hasAccessToResourceSize = function hasAccessToResourceSize(url, type, entry, hasTimingHeaders) {
    return !cacheableTypes.includes(type) || url.includes('localhost') || !!getWindowObject() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
var getReportedInitiatorTypes = function getReportedInitiatorTypes(xhrEnabled) {
    var ufoConfig = (0, _config.getConfig)();
    if (!(ufoConfig !== null && ufoConfig !== void 0 && ufoConfig.allowedResources)) {
        if (xhrEnabled) return [
            'script',
            'link',
            'fetch',
            'xmlhttprequest'
        ];
        return [
            'script',
            'link',
            'fetch'
        ];
    }
    return ufoConfig.allowedResources;
};
var evaluateAccessToResourceTimings = function evaluateAccessToResourceTimings(url, entry) {
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
var getSizeObject = function getSizeObject(size) {
    return size !== undefined ? {
        size: size
    } : null;
};
var getNetworkData = function getNetworkData(item, eventStart) {
    var hasTimingHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : evaluateAccessToResourceTimings;
    var name = item.name, duration = item.duration, transferSize = item.transferSize, initiatorType = item.initiatorType, responseStart = item.responseStart, requestStart = item.requestStart, serverTime = item.serverTime, networkTime = item.networkTime, encodedSize = item.encodedSize, decodedSize = item.decodedSize;
    var ttfb = (0, _roundNumber.roundEpsilon)(responseStart - eventStart);
    if (!hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if (cacheableTypes.includes(initiatorType)) {
        var transferType = calculateTransferType(initiatorType, duration, transferSize);
        return _objectSpread({
            ttfb: ttfb,
            transferType: transferType,
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: encodedSize,
            decodedSize: decodedSize
        }, getSizeObject(transferSize));
    }
    return _objectSpread({
        ttfb: ttfb,
        serverTime: serverTime,
        networkTime: networkTime,
        requestStart: requestStart
    }, getSizeObject(transferSize));
};
var getResourceTimings = function getResourceTimings(interactionStart, interactionEnd) {
    var resourceTiming = {};
    if (interactionStart === null) return resourceTiming;
    var resources = (0, _resourceTimingBuffer.filterResourceTimings)(interactionStart, interactionEnd);
    if (!(resources !== null && resources !== void 0 && resources.length)) return resourceTiming;
    var _getConfig = (0, _config1.getConfig)(), xhrFilter = _getConfig.xhrFilter, sanitiseEndpoints = _getConfig.sanitiseEndpoints, mapResources = _getConfig.mapResources, hasTimingHeaders = _getConfig.hasTimingHeaders;
    var reportedInitiatorTypes = getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach(function(item) {
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        var name = item.name, startTime = item.startTime, duration = item.duration, workerStart = item.workerStart, fetchStart = item.fetchStart, initiatorType = item.initiatorType;
        if (!name) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        var url = resourceTypes.includes(initiatorType) ? sanitiseEndpoints(name) : mapResources(name);
        if (!url || resourceTiming[url]) return;
        resourceTiming[url] = _objectSpread({
            startTime: (0, _roundNumber.roundEpsilon)(startTime - interactionStart),
            duration: (0, _roundNumber.roundEpsilon)(duration),
            workerStart: Math.max((0, _roundNumber.roundEpsilon)(workerStart - interactionStart), 0),
            fetchStart: Math.max((0, _roundNumber.roundEpsilon)(fetchStart - interactionStart), 0),
            type: initiatorType
        }, getNetworkData(item, interactionStart, hasTimingHeaders));
    });
    return resourceTiming;
};

},{"@babel/runtime/helpers/defineProperty":"2DsLZ","../config":"acZBX","../round-number":"dEmLP","./common/utils/config":"bZYSh","./common/utils/resource-timing-buffer":"f3YcN","@atlaspack/transformer-js/src/esmodule-helpers.js":"87JRQ"}],"f3YcN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resourceTimingBuffer", ()=>resourceTimingBuffer);
parcelHelpers.export(exports, "filterResourceTimings", ()=>filterResourceTimings);
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _roundNumber = require("../../../round-number");
var getPerformanceObject = function getPerformanceObject() {
    var _window;
    return ((_window = window) !== null && _window !== void 0 ? _window : {}).performance;
};
var getPerformanceObserverObject = function getPerformanceObserverObject() {
    var _window2;
    return ((_window2 = window) !== null && _window2 !== void 0 ? _window2 : {}).PerformanceObserver;
};
var resourceTimingBuffer = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: function transformResource(entry) {
        var _entry$serverTiming, _entry$serverTiming2;
        var duration = (0, _roundNumber.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        var totalBackendTimeEntry = ((_entry$serverTiming = entry.serverTiming) === null || _entry$serverTiming === void 0 ? void 0 : _entry$serverTiming.find(function(timing) {
            return timing.name === 'atl-edge';
        })) || ((_entry$serverTiming2 = entry.serverTiming) === null || _entry$serverTiming2 === void 0 ? void 0 : _entry$serverTiming2.find(// timing name should come from per-product config in the future
        function(timing) {
            return timing.name === 'total' || timing.name === 'filter-request-papi';
        }));
        var serverTime = totalBackendTimeEntry ? (0, _roundNumber.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        var networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, _roundNumber.roundEpsilon)(entry.startTime),
            duration: (0, _roundNumber.roundEpsilon)(entry.duration),
            fetchStart: (0, _roundNumber.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, _roundNumber.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, _roundNumber.roundEpsilon)(entry.responseStart || 0),
            requestStart: (0, _roundNumber.roundEpsilon)(entry.requestStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, _roundNumber.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, _roundNumber.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start: function start() {
        var _performance$getEntri;
        var performance = getPerformanceObject();
        var PerformanceObserver = getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if (resourceTimingBuffer.observer) return;
        var resources = (_performance$getEntri = performance.getEntriesByType) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri.call(performance, 'resource');
        if (resources) resourceTimingBuffer.timings = resources.map(function(resource) {
            return resourceTimingBuffer.transformResource(resource);
        });
        resourceTimingBuffer.observer = new PerformanceObserver(resourceTimingBuffer.addTimings);
        resourceTimingBuffer.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: function stop() {
        if (resourceTimingBuffer.observer) {
            resourceTimingBuffer.observer.disconnect();
            resourceTimingBuffer.observer = null;
        }
        resourceTimingBuffer.timings = [];
    },
    addTimings: function addTimings(list) {
        var _resourceTimingBuffer;
        var entries = list.getEntries().map(function(entry) {
            return resourceTimingBuffer.transformResource(entry);
        });
        var overflow = resourceTimingBuffer.timings.length + entries.length;
        if (overflow > resourceTimingBuffer.maxSize) {
            var fieldsToRemove = overflow - resourceTimingBuffer.maxSize;
            resourceTimingBuffer.timings.splice(0, fieldsToRemove);
        }
        (_resourceTimingBuffer = resourceTimingBuffer.timings).push.apply(_resourceTimingBuffer, (0, _toConsumableArrayDefault.default)(entries));
    }
};
var isValidTiming = function isValidTiming(timing, startTime, endTime) {
    return timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
};
var filterResourceTimings = function filterResourceTimings(startTime, endTime) {
    var performance = getPerformanceObject();
    var PerformanceObserver = getPerformanceObserverObject();
    if (!PerformanceObserver || !resourceTimingBuffer.observer) {
        var resources = performance === null || performance === void 0 ? void 0 : performance.getEntriesByType('resource');
        if (resources) return resources.filter(function(timing) {
            return isValidTiming(timing, startTime, endTime);
        });
        return null;
    }
    return resourceTimingBuffer.timings.filter(function(timing) {
        return isValidTiming(timing, startTime, endTime);
    });
};

},{"@babel/runtime/helpers/toConsumableArray":"gbrKk","../../../round-number":"dEmLP","@atlaspack/transformer-js/src/esmodule-helpers.js":"87JRQ"}],"AzgY4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startResourceTimingBuffer", ()=>startResourceTimingBuffer);
var _resourceTimingBuffer = require("./common/utils/resource-timing-buffer");
function startResourceTimingBuffer() {
    (0, _resourceTimingBuffer.resourceTimingBuffer).start();
}

},{"./common/utils/resource-timing-buffer":"f3YcN","@atlaspack/transformer-js/src/esmodule-helpers.js":"87JRQ"}],"1fEeT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "configure", ()=>configure);
parcelHelpers.export(exports, "getSSRTimings", ()=>getSSRTimings);
parcelHelpers.export(exports, "getSSRSuccess", ()=>getSSRSuccess);
parcelHelpers.export(exports, "getSSRDoneTime", ()=>getSSRDoneTime);
parcelHelpers.export(exports, "getSSRFeatureFlags", ()=>getSSRFeatureFlags);
var _typeof = require("@babel/runtime/helpers/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var NESTED_METRIC_SEPARATOR = '/';
var filterEntry = function filterEntry(entry) {
    return !(!entry || (0, _typeofDefault.default)(entry) !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
var mapEntry = function mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
var SSR_PREFIX = 'ssr';
var mapKey = function mapKey(key) {
    if (key === 'total') return SSR_PREFIX;
    return "".concat(SSR_PREFIX).concat(NESTED_METRIC_SEPARATOR).concat(key);
};
var config;
function configure(ssrConfig) {
    config = ssrConfig;
}
function getSSRTimings() {
    var _config;
    if (!((_config = config) !== null && _config !== void 0 && _config.getTimings)) return {};
    var timings = config.getTimings();
    if (!timings) return {};
    var ssrTimings = Object.entries(timings).reduce(function(acc, entry) {
        if (filterEntry(entry[1])) acc[mapKey(entry[0])] = mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function getSSRSuccess() {
    var _config2;
    return !!((_config2 = config) !== null && _config2 !== void 0 && _config2.getDoneMark());
}
function getSSRDoneTime() {
    var _config$getDoneMark, _config3;
    return (_config$getDoneMark = (_config3 = config) === null || _config3 === void 0 ? void 0 : _config3.getDoneMark()) !== null && _config$getDoneMark !== void 0 ? _config$getDoneMark : undefined;
}
function getSSRFeatureFlags() {
    var _config4;
    if (!((_config4 = config) !== null && _config4 !== void 0 && _config4.getFeatureFlags)) return undefined;
    try {
        var _config$getFeatureFla;
        return (_config$getFeatureFla = config.getFeatureFlags()) !== null && _config$getFeatureFla !== void 0 ? _config$getFeatureFla : undefined;
    // eslint-disable-next-line no-empty
    } catch (e) {}
    return undefined;
}

},{"@babel/runtime/helpers/typeof":"7CsQn","@atlaspack/transformer-js/src/esmodule-helpers.js":"87JRQ"}],"2tBtR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sanitizeUfoName", ()=>sanitizeUfoName);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "isSegmentLabel", ()=>isSegmentLabel);
var sanitizeUfoName = function sanitizeUfoName(name) {
    return name.replace(/_/g, '-');
};
function isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"87JRQ"}]},[], null, "parcelRequire0a87")

//# sourceMappingURL=create-payload.846d97a0.js.map
